{"CANISTER_ID_BACKEND":"u64er-ryaaa-aaaah-arlna-cai","DFX_NETWORK":"ic_odoc","BUILD_TIME":"2025-11-04 21:04:31"}